import { useState } from 'react';
import { FaGhost, FaUsers, FaGlobeAmericas } from 'react-icons/fa';
import ActivityFeed from '../components/ActivityFeed';
import { useDarkMode } from '../context/DarkModeContext';
import { useAuth } from '../context/AuthContext';

const Activity = () => {
  const { darkMode } = useDarkMode();
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('feed');

  const tabs = [
    { id: 'feed', label: 'My Feed', icon: FaUsers, requiresAuth: true },
    { id: 'global', label: 'Global Activity', icon: FaGlobeAmericas, requiresAuth: false },
  ];

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-dark-bg text-ghost-white' : 'bg-gray-50 text-gray-900'}`}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold flex items-center gap-3 mb-2">
            <FaGhost className="text-purple-500" />
            Activity
          </h1>
          <p className={`text-lg ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            {activeTab === 'feed'
              ? 'See what the users you follow are up to'
              : 'Discover what\'s happening across the platform'
            }
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mb-6 border-b border-gray-700">
          {tabs.map((tab) => {
            // Hide tabs that require auth if user is not logged in
            if (tab.requiresAuth && !currentUser) return null;

            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors ${
                  activeTab === tab.id
                    ? darkMode
                      ? 'text-purple-400 border-b-2 border-purple-400'
                      : 'text-purple-600 border-b-2 border-purple-600'
                    : darkMode
                    ? 'text-gray-400 hover:text-gray-300'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                <Icon />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Activity Feed */}
        {activeTab === 'feed' && currentUser ? (
          <ActivityFeed type="feed" />
        ) : activeTab === 'global' ? (
          <ActivityFeed type="global" />
        ) : !currentUser ? (
          <div className={`text-center py-12 ${darkMode ? 'bg-dark-surface' : 'bg-white'} rounded-lg`}>
            <FaGhost className="text-6xl mx-auto mb-4 opacity-50" />
            <h3 className="text-xl font-semibold mb-2">Sign in to see your feed</h3>
            <p className={darkMode ? 'text-gray-400' : 'text-gray-600'}>
              Follow users to see their activity in your personalized feed
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Activity;
